import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import campaigns from './modules/campaigns'
import badges from './modules/badges'
import modals from './modules/modals'
import events from './modules/events'
import user from './modules/user'
import sites from './modules/sites'
import account from './modules/account'
import libraries from './modules/libraries'
import medias from './modules/medias'
import challenges from './modules/challenges'
import wheel from './modules/wheel'
import gifts from './modules/gifts'
import contest from './modules/contest'
import rounds from './modules/rounds'
import customers from './modules/customers'
import bubbles from './modules/bubbles'
import kpis from './modules/kpis'
import advices from './modules/advices'
import monsters from './modules/monsters'
import waves from './modules/waves'
import banners from './modules/banners'
import surveys from './modules/surveys'

Vue.use(Vuex)

const debug = false
const token = localStorage.getItem('token')
if (token) {
  axios.defaults.headers.common['X-Token'] = token
}

export default new Vuex.Store({
  modules: {
    campaigns,
    badges,
    modals,
    events,
    user,
    sites,
    account,
    libraries,
    medias,
    challenges,
    wheel,
    gifts,
    contest,
    rounds,
    customers,
    bubbles,
    kpis,
    advices,
    monsters,
    waves,
    banners,
    surveys
  },
  strict: debug,
  plugins: []
})



// WEBPACK FOOTER //
// ./src/store/index.js